import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog } from '../../actions';
import { getAllCentros, deleteCentroDB } from '../../actions/centro_actions';
import { getEmpresas } from '../../actions/empresa_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeCentro extends Component {

    constructor(props) {
        super(props);

        this.state = {
            centros: []
        }

    }

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getAllCentros();
        this.props.getEmpresas();
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.refresh) {
            this.props.getAllCentros();
            this.props.getEmpresas();
        }
        else if (this.props.centros !== prevProps.centros) {


            let ord_centros = this.props.centros.slice();

            ord_centros.sort((a, b) => { return b.activo - a.activo });

            this.setState({ ...this.state, centros: ord_centros })

        }
    };

    editCentro = (centro) => {
        this.props.navigate("edit_centro/" + centro.id);
    };

    newCentro = () => {
        this.props.openDialog('CentroNew', {}, uuidv4());
    };

    deleteCentro = centro => {
        this.props.openDialog('ConfirmationDialog', {
            message: '¿Desea borrar definitivamente el centro ' + this.props.centros.find(c => c.id === centro.id).centro + '? \n NO es posible deshacer esta operación',
            acceptHandler: () => {
                this.props.deleteCentroDB(centro.id);
            }
        }, uuidv4(), false, 'sm');

    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <NeuriteGrid
                    id="m_c"
                    columns={[
                        { key: 'activo', name: 'Activo', type: 'bool', editable: false, dragable: false, width: 52 },
                        { key: 'centro', name: 'Centro', editable: false, dragable: false },
                        { key: 'empresa', name: 'Empresa', editable: false, dragable: false },
                    ]}
                    rows={this.state.centros}
                    height={500}
                    buttonEdit={true}
                    buttonDelete={true}
                    buttonNew={true}
                    onNewRowClick={this.newCentro}
                    onEditClick={this.editCentro}
                    onDeleteClick={this.deleteCentro}
                />
            </div>
        );

    };
};

MaeCentro.propTypes = {
    //state:
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    refresh: PropTypes.bool.isRequired,
    //dispatch:
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    getEmpresas: PropTypes.func.isRequired,
    deleteCentroDB: PropTypes.func.isRequired,
};

function mapStateToProps(state) {

    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        refresh: state.centros.refresh
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate: navigate,
        openDialog: openDialog,
        getAllCentros,
        getEmpresas,
        deleteCentroDB: deleteCentroDB
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaeCentro));